<div [formGroup]="Group">
  <label class="w-100" id="label_{{Control.label}}" [translation]="TranslationEnum.TranslationForm">
    {{('label_'+ Control.label)|translate}} </label>
  <img width='60%' [src]="Src" (click)="openRenderPreviewDialog()">
</div>
